export default __webpack_public_path__ + "static/media/f-and-b.3065a861.svg";